import { getAuthAxiosBackend } from "@/helpers/axios"

class PositionsServices {
    get(id) {
        return getAuthAxiosBackend().get('Positions/getPositionsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Positions/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Positions/addedPositions', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Positions/updatePositions/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Positions/restorePositions' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Positions/softDeletePositions/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Positions/deletePositions/' + id.toString())
    }
}

export default new PositionsServices()
